var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 35,
    height: 34,
    rx: 6,
    stroke: "#FF5858",
    strokeOpacity: 0.47,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H27M26 13L25.133 25.142C25.0971 25.6466 24.8713 26.1188 24.5011 26.4636C24.1309 26.8083 23.6439 27 23.138 27H14.862C14.3561 27 13.8691 26.8083 13.4989 26.4636C13.1287 26.1188 12.9029 25.6466 12.867 25.142L12 13H26ZM17 17V23V17ZM21 17V23V17ZM22 13V10C22 9.73478 21.8946 9.48043 21.7071 9.29289C21.5196 9.10536 21.2652 9 21 9H17C16.7348 9 16.4804 9.10536 16.2929 9.29289C16.1054 9.48043 16 9.73478 16 10V13H22Z",
    stroke: "#FF5858",
    strokeOpacity: 0.66,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.65a5b5337f7def9b9c88d817e14a8da8.svg";
export { ForwardRef as ReactComponent };